// extracted by mini-css-extract-plugin
export var collapsedSummary = "_sm-0";